import React, {useState, useEffect} from "react";

function Card(data, deptImport, deptChoice, employeeName) {

  const [name, setName] = useState('');
  const [nameContact, setContact] = useState('');
  const [hideClass, setHide] = useState('hide-contact');
  const [nameFilter, setNameFilter] = useState('');
  const [image, setImage] = useState(''); // Need to figure out the embedded link
  const [title, setTitle] = useState('');
  const [deptID, setDeptID] = useState(''); // Department ID is taken from Card(data).
  const [deptName, setDeptName] = useState(''); // We set this from the info in dataImport but dataImport returns empty object wherever we use it, I honestly have no idea why this works but we need it lol.
  const [year, setYear] = useState('');
  const [phone, setPhone] = useState('N/A');
  const [deptFilter, setDeptFilter] = useState('');
  const [deptShow, hideDept] = useState('dept-hidden');
  const employee = data;

  useEffect(() =>  {
    // const employee = data;
    // setDeptFilter(data.deptChoice);
    // setDeptFilter(employee.deptChoice);
    // getData(employee.data);
    // console.log("we're in a dept FILTER cardjs");
    // console.log(deptFilter);
    if(deptFilter != 0 && deptFilter != deptID) {
      hideDept('dept-hidden');
    } else {
      hideDept('');
    }
  }, [deptFilter]);

  useEffect(() =>  {
    // const employee = data;
    // setDeptFilter(data.deptChoice);
    // setDeptFilter(employee.deptChoice);
    // getData(employee.data);
    // console.log("we're in name filter");
    // console.log(nameFilter);
    let searched = nameSearch(nameFilter);
    // if(searched && (deptFilter == 0 || deptFilter == deptID)) { // combined name + department power
    if(searched) {
      // console.log("we found: " + searched);
      hideDept('');
    } else {
      hideDept('dept-hidden');
    }
  }, [nameFilter]);

  function nameSearch(query) {
    if(query === undefined)
      return true;
    // console.log("nameSearch " + query);
    query = query.toLowerCase();
    // console.log(name);
    const check = name.split(' ').some(word =>
      word.toLowerCase().startsWith(query)
    );
    // if(check) 
    //   console.log("SOMETHING TRUE??? " + name);
    return check;
  }

  useEffect(() =>  {
    // const employee = data;
    // setDeptFilter(data.deptChoice);
    setDeptFilter(employee.deptChoice);
    getData(employee.data);
  }, ['']);


  useEffect(() => {
    // console.log("just another test....");
    setDeptFilter(employee.deptChoice);
    // console.log(employee.employeeName);
    setNameFilter(employee.employeeName);
    getData(employee.data);
    // console.log("just checking something: "); 
    // console.log(employee.data);
  });


  useEffect(() => {
    // console.log("deptid in cardjs");
    // console.log(deptID);
    let departments = data.deptImport;
    departments.forEach((department, index) => {
      if(department.id == deptID) {
        setDeptName(department.name);
        return;
      }
    });
    // console.log(data.dataImport);
    // console.log(data.deptChoice);
  }, [deptID]);

  useEffect(() => {
    // console.log("deptname in cardjs");

    // console.log(deptName);
    // console.log(deptFilter);
    if(deptFilter === deptID || deptFilter === 0) {
      // console.log("boutta UNhide it");
      // console.log("filter: " + deptFilter + " ID: " + deptID);
      hideDept('');
    } 
  }, [deptName]);

  // Use this to check if we should add the Contact to single employee page.
  useEffect(() => {
    let contactLink = name.replace(/\s+/g, '-').toLowerCase();
    console.log("Title change with contact link: ");
    setContact("/employee/"+contactLink);
    if(title == 'Territory Manager') {
      setHide('');
    }
  }, [title]);

  function featImage(data) {
    let featuredMedia;
    if (data && data._embedded && data._embedded['wp:featuredmedia']) {
      featuredMedia = data._embedded['wp:featuredmedia'][0].source_url;
      if(featuredMedia === undefined)
        featuredMedia = '/wp-content/uploads/2024/04/people-placeholder-logo.jpg';
    } else
      featuredMedia = '/wp-content/uploads/2024/04/people-placeholder-logo.jpg';
    return featuredMedia;
  }

  function getData(data) {
    setImage(featImage(data));
    setDeptID(data.department[0]);
    setName(data.title.rendered);
    setTitle(data.acf.employee_title);
    setYear(data.acf.employee_year);
    if(data.acf.employee_phone)
      setPhone(data.acf.employee_phone);
  }

  return(
    <div className={`directory-people-item ${deptShow}`}>
      <div className="employee-header">
        <img alt={`headshot of ${name}`} src={image} loading="lazy"/>
        <h3>{name}</h3>
      </div>
      <div className="employee-main">
        <div className="employee-body">
          <p className="employee-title">{title}</p>
          <p className="employee-department">{deptName}</p>
          <p className="employee-year">With Kraft since: {year} </p>
        </div>
      </div>
      <div className="employee-contact">
        <a target="__blank" href={`tel:+1 ${phone}`}  className="employee-phone">{phone}</a>
        <a class={`territory-contact ${hideClass}`} href={`/employee/${nameContact}`}>Contact <img class="logo-arrow" alt=""  src="/wp-content/uploads/2024/03/icon-arrow.svg"/></a>
      </div>
    </div>
  );
}

export default Card;